import * as h2Api from '../../h2Api'

export const AUDIO_LOADED = 'AUDIO_LOADED'
export const SET_AUTOPLAY_STATE = 'AUDIO_SET_AUTOPLAY_STATE'
export const REGISTER_PLAYER = 'AUDIO_REGISTER_PLAYER'
export const UNREGISTER_PLAYER = 'AUDIO_UNREGISTER_PLAYER'
export const SET_TIMINGS = 'AUDIO_SET_TIMINGS'
export const PLAYER_STATE = 'AUDIO_PLAYER_STATE'
export const TIMINGS_PREV_WORD = 'AUDIO_TIMINGS_PREV_WORD'
export const TOGGLE_IS_AUDIO_PLAYING = 'TOGGLE_IS_AUDIO_PLAYING'

export const generateAudio = t => dispatch => {
  dispatch(h2Api.post('/api/v2/early/speech/read', { text: t })({ type: AUDIO_LOADED }))
}

export const setAudioAutoPlay = s => (dispatch, getState) => {
  const loadedGameId = getState().early.gameboard.loadedGameId

  return dispatch(
    h2Api.post(`/early/${loadedGameId}/audio`, { audio: s })({
      type: SET_AUTOPLAY_STATE,
      value: s
    })
  )
}

export const registerPlayer = s => dispatch => {
  dispatch({ type: REGISTER_PLAYER, value: s })
}

export const setIsAudioPlaying = isPlaying => {
  return { type: TOGGLE_IS_AUDIO_PLAYING, isPlaying }
}

export const unregisterPlayer = s => dispatch => {
  dispatch({ type: UNREGISTER_PLAYER, value: s })
}

export const setTimings = t => dispatch => {
  dispatch({ type: SET_TIMINGS, value: t })
}

export const timingListener = timings => (dispatch, getState) => {
  return e => {
    //console.log("Timing", e)
    if (!e) {
      return
    }

    const currTime = e.currentTime * 1000
    //console.log(currTime)
    let currentWord = ''
    //console.log(timings)
    const state = getState().early.audio
    const t = timings.filter(t => t.time <= currTime)
    const eleT = t[t.length - 1]

    currentWord = (eleT || { value: '' }).value

    if (state.prevWord != currentWord) {
      dispatch({ type: TIMINGS_PREV_WORD, prevWord: eleT, currTime })
      //this.forceUpdate()
    }

    //console.log(currentWord, currTime);
  }
}

export const startPlay = () => (dispatch, getState) => {
  const timings = getState().early.audio.timings
  const list = dispatch(timingListener(timings))

  return e => {
    //console.log(e)
    e.persist()
    const intervalId = setInterval(() => list(e.target), 50)

    dispatch({ type: PLAYER_STATE, playing: true, ended: false, timerId: intervalId })
  }
}

export const endPlay = () => (dispatch, getState) => {
  return e => {
    //console.log("ENDED", e, myThis.state.timerId)
    const timerId = getState().early.audio.timerId

    if (timerId) {
      clearTimeout(timerId)
    }

    dispatch({ type: PLAYER_STATE, playing: false, ended: true, timerId: null })
  }
}

export const stopPlay = () => (dispatch, getState) => {
  return e => {
    //console.log("ENDED", e, myThis.state.timerId)
    const timerId = getState().early.audio.timerId

    if (timerId) {
      clearTimeout(timerId)
    }

    dispatch({ type: PLAYER_STATE, playing: false, ended: false, timerId: null })
  }
}
